import React, { useState} from "react";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/Tab";
import { toast } from "react-toastify";
import Toast from "../LoadingError/Toast";
import axios from "axios";
import { BASE_URL } from "../../api/baseConfig";
import { ICatalogEdit } from "./MainCatalog";
import { ICatalogCreate } from "./MainCatalog";
import { langTypes } from "@/types";
const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};
type language = {name: string, id: number}
const languages: language[] = [{name: "AZ", id: 1}, {name: "EN", id: 2}, {name: "TR", id: 3}, {name: "RU", id: 4}]

const initialLangNames = [
  {name: "", lang_code: "AZ"},
  {name: "", lang_code: "EN"},
  {name: "", lang_code: "TR"},
  {name: "", lang_code: "RU"},
]

interface ICreateCatalogProps {
  catalog: ICatalogEdit | null | ICatalogCreate
  onCancelEdit: () => void
  loadDirectors: (page: number, lang: langTypes) => void
  page: number
}

const CreateCatalog = (props: ICreateCatalogProps) => {

  const [slugName,setSlugName] = useState("")
  const [langNames, setLangNames] = useState(initialLangNames);
  const token = JSON.parse(localStorage.getItem("userInfo")!).token;


  const createCatalog = React.useCallback((catalog: ICatalogCreate) => {
    axios
      .post(BASE_URL + "/api/catalogs/add", catalog, {
        headers: { "x-access-token": token },
      })
      .then((response) => {
        props.loadDirectors(props.page, 'AZ');
        toast.success("Catalog created successfully", ToastObjects);
      });

  }, [props, token]);
  const editCatalog = React.useCallback((catalog: ICatalogEdit) => {
    axios
      .put(BASE_URL + "/api/catalogs/update/" + catalog.id, catalog, {
        headers: { "x-access-token": token },
      })
      .then((response) => {
        props.loadDirectors(props.page, 'AZ');
        toast.success("Catalog edited successfully", ToastObjects);
        props.onCancelEdit()
      });

  }, [props, token]);
  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (props.catalog && 'id' in props.catalog) {
      editCatalog({id: props.catalog.id, language: langNames, slug: slugName})
      
    } else {
      createCatalog({language: langNames, slug: slugName})
    }
    setLangNames(initialLangNames);
    setSlugName("")
    }

  
  React.useEffect(() => {
    if (props.catalog) {
      setLangNames(props.catalog.language);
      setSlugName(props.catalog.slug);
    } else {
      setLangNames(initialLangNames);
      setSlugName("");
    }
  }, [props.catalog])

  const langNameChangeHandler = React.useCallback((language: language, newValue: string) => {
    setLangNames((prev) => {
      const newLangNames = [...prev];
      const langCode = language.name;
      const langIndex = newLangNames.findIndex((l) => l.lang_code === langCode);
      const newLangValue = {...newLangNames[langIndex]};
      newLangValue.name = newValue;
      newLangNames[langIndex] = newLangValue;
      return newLangNames
    });
  }, [])

  return (
    <>
    <Toast />
    <div className="col-md-12 col-lg-4">
      <form onSubmit={submitHandler}>
        <Tabs defaultActiveKey="AZ" id="catalog-language-tabs" className="mb-3">
          {languages &&
              languages.map((l) => {
                  const langName = langNames.find(ln => ln.lang_code === l.name);
                  const value = langName ? langName.name : '';

                  return (
                      <Tab eventKey={l.name} title={l.name} key={`movie-tab-${l.id}`}>
                          <div className="mb-4">
                              <label
                                  htmlFor={`product_title-${l.id}`}
                                  className="form-label"
                              >
                                  catalog title {l.name}
                              </label>
                              <input
                                  type="text"
                                  placeholder="Type here"
                                  className="form-control"
                                  id={`product_title-${l.id}`}
                                  name="name"
                                  required
                                  value={value}
                                  onChange={e => langNameChangeHandler(l, e.target.value)}
                              />
                          </div>
                      </Tab>
                  );
              })}
        </Tabs>
        <div className="mb-4">
          <label htmlFor="slug">Slug</label>
          <input className="form-control"
            placeholder="slug" id="slug" name="slug" value={slugName}
            required
            onChange={e=>setSlugName(e.target.value)}
            />
        </div>
        <div className="d-grid">
          {props.catalog?.language? (
            <>
            <button className="btn btn-warning py-3 mb-3" type="submit">Edit Catalog</button>
            <button type="button" onClick={props.onCancelEdit} className="btn btn-secondary py-3">Cancel</button>

            </>
          

          ):(
            <button type="submit" className="btn btn-primary py-3">Create Catalog</button>
          )}
        </div>
      </form>
    </div>
  </>
  );
};

export default CreateCatalog;
